import React, { useState, useRef, Suspense, useEffect } from 'react';
import _ from 'lodash';

import Spinner from 'design-system/Spinner';
import TaskComponent from 'react-scale/components/Task/TaskComponent';
import { ShortcutsProvider } from 'react-scale/hooks/useShortcut';
import { sampleTask } from '@scale/shared/selfServe/validationHelpers';
import { useInstructionTaskData } from 'react-scale/dashboard.scale.com/components/SelfServe/Instructions/hooks';
import useUnprocessedAttachments from 'react-scale/studio/hooks/useUnprocessedAttachments';

interface ExampleViewerProps {
  linkedTask: string;
}

const ExamplePreview: React.FC<ExampleViewerProps> = ({ linkedTask }: { linkedTask: string }) => {
  const [loading, setLoading] = useState(false);
  const taskRef = useRef<$FIXME>();
  const [taskProps, setTaskProps] = useState<any>(undefined);
  const { data: taskData = {} } = useInstructionTaskData(linkedTask, true, undefined, true);
  const { params, response, type, projectId } = taskData;
  const { fetchUnprocessedAttachments } = useUnprocessedAttachments();

  useEffect(() => {
    let canceled = false;
    async function fetchData() {
      if (!loading && params && type && projectId) {
        setTaskProps(undefined);
        setLoading(true);
        const taskParams = params;

        if (
          taskParams &&
          taskParams.attachments &&
          taskParams.attachments.length > 0 &&
          _.every(taskParams.attachments, a => a.type === 'unprocessed')
        ) {
          taskParams.attachments = await fetchUnprocessedAttachments(taskParams.attachments ?? []);
        }

        if (!canceled) {
          setTaskProps({
            ...sampleTask,
            assignment: {
              params: taskParams,
              projectId,
              type,
            },
            type,
            params: taskParams,
            fixResponse: response,
            timerDisabled: true,
            shouldWarnOnExit: false,
            readOnly: true,
            editable: false,
            isCustomer: true,
            showHeader: false,
            isTaxonomyDisplay: true,
            showFooter: false,
          });
        }
      }
      setLoading(false);
    }

    fetchData();
    return function cleanup() {
      canceled = true;
    };
  }, [params, type, projectId]);

  return (
    <>
      {taskProps && (
        <>
          <Suspense fallback={<Spinner style={{ paddingBottom: '16px' }} />}>
            <div className="component">
              <ShortcutsProvider>
                <TaskComponent
                  taskType={taskProps.type}
                  taskProps={taskProps}
                  taskRef={taskRef}
                  isTaxonomyDisplay={true}
                  compact
                />
              </ShortcutsProvider>
            </div>
          </Suspense>
        </>
      )}

      <style jsx global>{`
        .component {
          height: 400px;
        }
        .component,
        .component .task {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
          min-width: 0;
          width: 100%;
          overflow: auto;
        }

        .task__splitpane {
          position: relative;
          overflow: auto;
        }
      `}</style>
    </>
  );
};

export default ExamplePreview;
